export default {
  name: 'TechCycle',
  by: 'TrendCycle',
  year: 2018,
  navs: [
    {key: 'privacy'},
    {key: 'terms'},
    {key: 'about'},
  ],
  key: {
    lastUpdated: 'lastUpdated',
    country: 'country',
    cookie: 'cookie',
    background: 'background',
  },
  backgrounds: ['aurora', 'coalesce', 'pipeline', 'shift', 'swirl'],
  backgroundImages: [
    //'/img/bg0.jpeg',
    '/img/photo-1500393600906-a3136b3c5f70.jpeg',
    '/img/photo-1492011221367-f47e3ccd77a0.jpeg',
    '/img/photo-1493632230625-5260c73a3121.jpeg',
    '/img/photo-1507908708918-778587c9e563.jpeg',
    '/img/photo-1435224654926-ecc9f7fa028c.jpeg',
    '/img/photo-1500390365106-166bb67248d6.jpeg',
  ],
  languages: [
    {key:'english',code:'en'},
    {key:'malay',code:'my'},
    {key:'deutsch',code:'de'},
    {key:'chinese',code:'cn'},
    {key:'hindi',code:'hi'},
  ]
}
